<template>
  <div>
    <!-- 공지 쓰기 버튼 -->

    <!-- TODO: 공지 기능이 완성되면 주석풀고 사용 -->
    <!--
    <b-button v-if="is_admin === 4" variant="teal" size="sm" class="mb-2" @click="openWriteNoticeModal">
      <b-icon icon="pen"/>
      공지 쓰기(관리자)
    </b-button>
    -->

    <div role="tablist">
      <b-button
        v-b-toggle.notices
        variant="teal"
        block
        class="text-left mb-2 d-flex justify-content-between align-items-center button-with-icon"
        role="tab"
        @click="toggleCollapse('notices')"
      >
        공지사항
        <b-icon
          class="collapse-icon"
          :icon="isNoticesCollapsed ? 'caret-up-fill' : 'caret-down-fill'"
        />
      </b-button>

      <b-collapse id="notices" role="tabpanel" visible accordion="my-accordion">
        <template v-if="notice_list && notice_list.length > 0">
          <p v-if="unreadCount > 0">
            확인되지 않은 공지가 <span class="red">{{ unreadCount }}</span
            >개 있습니다.
          </p>
          <b-card
            v-for="notice in notice_list"
            :key="notice.notice_id"
            no-body
            class="px-3 py-2 w-100 mb-1 cursor notice-card"
            @click="openNoticeModal(notice)"
          >
            <div>
              <p class="f-85 fw-500">{{ notice.title }}</p>
              <div class="d-flex justify-content-between">
                <p class="mb-0 f-85 fw-300">{{ formatTimestamp(notice.time_stamp) }}</p>
                <template v-if="isNoticeRead(notice.notice_id)">
                  <b-icon class="mr-1" scale="1.1" variant="success" icon="check2-square" />
                </template>
                <template v-else>
                  <b-icon class="mr-1" scale="1.1" variant="danger" icon="square" />
                </template>
              </div>
            </div>
          </b-card>
        </template>
        <template v-else>
          <b-card no-body class="px-3 py-2 w-100 f-85 mb-3"> 등록된 공지가 없습니다. </b-card>
        </template>
      </b-collapse>
      <b-button
        v-b-toggle.messages
        variant="teal"
        block
        class="text-left mb-2 d-flex justify-content-between align-items-center button-with-icon"
        role="tab"
        @click="toggleCollapse('messages')"
      >
        <div>
          메시지
          <span v-if="new_notice" class="red">{{ new_notice }}</span>
        </div>

        <b-icon
          class="collapse-icon"
          :icon="isMessagesCollapsed ? 'caret-up-fill' : 'caret-down-fill'"
        />
      </b-button>

      <b-collapse id="messages" role="tabpanel" accordion="my-accordion">
        <!-- 읽음/읽지 않음 탭 -->
        <b-tabs v-model="messageTabIndex" content-class="mt-2" small>
          <b-tab>
            <template #title>
              읽지 않음
              <b-badge v-if="filteredUnreadMentions.length" variant="danger" pill class="ml-1">{{
                filteredUnreadMentions.length
              }}</b-badge>
            </template>
            <!-- 작성자 검색 -->
            <div class="mb-2">
              <b-input-group size="sm">
                <b-form-input
                  v-model="searchKeyword"
                  placeholder="작성자 검색"
                  @input="clearSelection"
                />
                <b-input-group-append v-if="searchKeyword">
                  <b-button variant="outline-secondary" @click="searchKeyword = ''">
                    <b-icon icon="x" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <template v-if="filteredUnreadMentions.length > 0">
              <div class="mb-1">
                <b-form-checkbox
                  :checked="isAllUnreadSelected"
                  :indeterminate="isUnreadIndeterminate"
                  size="sm"
                  @change="toggleSelectAllUnread"
                >
                  전체 선택
                </b-form-checkbox>
                <div v-if="selectedIds.length > 0" class="d-flex mt-1" style="gap: 4px">
                  <b-button
                    variant="outline-primary"
                    size="sm"
                    class="flex-fill"
                    @click="markSelectedAsRead"
                  >
                    <b-icon icon="envelope-open" class="mr-1" />선택 읽음 ({{ selectedIds.length }})
                  </b-button>
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    class="flex-fill"
                    @click="deleteSelectedMentions"
                  >
                    <b-icon icon="trash" class="mr-1" />선택 삭제 ({{ selectedIds.length }})
                  </b-button>
                </div>
              </div>
              <b-card
                v-for="mention in filteredUnreadMentions"
                :key="mention.id"
                no-body
                class="px-3 py-2 w-100 mb-1 cursor mention-card"
                :class="{ 'mention-card-selected': selectedIds.includes(mention.id) }"
                @click="handleMentionClick(mention)"
              >
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <div class="mention-labels">
                    <span class="mention-label-report">{{ mention.report_name }}</span>
                  </div>
                  <b-form-checkbox
                    :checked="selectedIds.includes(mention.id)"
                    @change="toggleSelect(mention.id)"
                    @click.native.stop
                  />
                </div>
                <div class="mention-labels mb-1">
                  <span v-if="mention.sb_toc_lv1_name" class="mention-label-topic">{{
                    mention.sb_toc_lv1_name
                  }}</span>
                  <span v-if="mention.sb_toc_lv2_name" class="mention-label-topic">{{
                    mention.sb_toc_lv2_name
                  }}</span>
                </div>
                <p class="mb-0 f-85">
                  {{ mention.sender_name }} :
                  <span v-html="formatMentionPreview(mention.content, 45)"></span>
                </p>
                <p class="mb-0 mention-timestamp">{{ formatTimestamp(mention.time_stamp) }}</p>
              </b-card>
            </template>
            <template v-else>
              <b-card no-body class="px-3 py-2 w-100 f-85 mb-3">
                {{ searchKeyword ? '검색 결과가 없습니다.' : '읽지 않은 메시지가 없습니다.' }}
              </b-card>
            </template>
          </b-tab>

          <b-tab>
            <template #title> 읽음 </template>
            <!-- 작성자 검색 -->
            <div class="mb-2">
              <b-input-group size="sm">
                <b-form-input
                  v-model="searchKeyword"
                  placeholder="작성자 검색"
                  @input="clearSelection"
                />
                <b-input-group-append v-if="searchKeyword">
                  <b-button variant="outline-secondary" @click="searchKeyword = ''">
                    <b-icon icon="x" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </div>
            <template v-if="filteredReadMentions.length > 0">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <b-form-checkbox
                  :checked="isAllReadSelected"
                  :indeterminate="isReadIndeterminate"
                  size="sm"
                  @change="toggleSelectAllRead"
                >
                  전체 선택
                </b-form-checkbox>
                <b-button
                  v-if="selectedIds.length > 0"
                  variant="outline-danger"
                  size="sm"
                  @click="deleteSelectedMentions"
                >
                  <b-icon icon="trash" class="mr-1" />선택 삭제 ({{ selectedIds.length }})
                </b-button>
              </div>
              <b-card
                v-for="mention in filteredReadMentions"
                :key="mention.id"
                no-body
                class="px-3 py-2 w-100 mb-1 cursor mention-card mention-card-read"
                :class="{ 'mention-card-selected': selectedIds.includes(mention.id) }"
                @click="handleMentionClick(mention)"
              >
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <div class="mention-labels">
                    <span class="mention-label-report">{{ mention.report_name }}</span>
                  </div>
                  <b-form-checkbox
                    :checked="selectedIds.includes(mention.id)"
                    @change="toggleSelect(mention.id)"
                    @click.native.stop
                  />
                </div>
                <div class="mention-labels mb-1">
                  <span v-if="mention.sb_toc_lv1_name" class="mention-label-topic">{{
                    mention.sb_toc_lv1_name
                  }}</span>
                  <span v-if="mention.sb_toc_lv2_name" class="mention-label-topic">{{
                    mention.sb_toc_lv2_name
                  }}</span>
                </div>
                <p class="mb-0 f-85">
                  {{ mention.sender_name }} :
                  <span v-html="formatMentionPreview(mention.content, 45)"></span>
                </p>
                <p class="mb-0 mention-timestamp">{{ formatTimestamp(mention.time_stamp) }}</p>
              </b-card>
            </template>
            <template v-else>
              <b-card no-body class="px-3 py-2 w-100 f-85 mb-3">
                {{ searchKeyword ? '검색 결과가 없습니다.' : '읽은 메시지가 없습니다.' }}
              </b-card>
            </template>
          </b-tab>
        </b-tabs>
      </b-collapse>

      <b-button
        v-b-toggle.activity-logs
        variant="teal"
        block
        class="text-left mb-2 d-flex justify-content-between align-items-center button-with-icon"
        role="tab"
        @click="toggleCollapse('activityLogs')"
      >
        활동 기록
        <b-icon
          class="collapse-icon"
          :icon="isActivityLogsCollapsed ? 'caret-up-fill' : 'caret-down-fill'"
        />
      </b-button>

      <b-collapse id="activity-logs" role="tabpanel" accordion="my-accordion">
        <template v-if="activity_logs_loaded == true">
          <b-card v-for="log in activity_logs" :key="log.id" no-body class="px-3 py-2 mb-1 w-100">
            <p class="f-85">{{ log.activity }}</p>
            <div class="d-flex justify-content-between align-items-center">
              <p class="f-85 mb-0">{{ log.time_stamp }}</p>
              <div
                v-b-tooltip.hover
                :title="getReportName(log.report_code)"
                class="px-1"
                :style="`color:${getMainColor(log.report_code)}`"
              >
                <fa icon="bookmark" />
              </div>
            </div>
          </b-card>
        </template>
      </b-collapse>
    </div>

    <!-- 공지 쓰기 모달 -->
    <b-modal
      id="write-notice-modal"
      title="공지 쓰기(테스트중)"
      hide-footer
      size="xl"
      centered
      scrollable
      @hide="resetNoticeForm"
    >
      <b-form @submit.prevent="submitNotice">
        <b-form-group label="제목" label-for="notice-title">
          <b-form-input id="notice-title" v-model="noticeForm.title" required />
        </b-form-group>
        <b-form-group label="내용" label-for="notice-content">
          <b-form-textarea id="notice-content" v-model="noticeForm.content" rows="5" required />
        </b-form-group>
        <b-button variant="teal" class="mr-2" @click="submitNotice">등록</b-button>
        <b-button variant="secondary" @click="$bvModal.hide('write-notice-modal')">취소</b-button>
      </b-form>
    </b-modal>

    <!-- 공지사항 상세 모달 -->
    <b-modal
      id="notice-modal"
      :title="selectedNotice ? selectedNotice.title : ''"
      size="xl"
      centered
      scrollable
      @hide="markNoticeAsRead(selectedNotice)"
    >
      <div v-if="selectedNotice">
        <component :is="selectedNotice.component" v-if="selectedNotice.component" />
        <p v-else v-html="formatContent(selectedNotice.content)"></p>

        <!-- Download Attachment Link -->
        <div v-if="selectedNotice.attachment" class="mt-3">
          <a
            :href="selectedNotice.attachment.url"
            target="_blank"
            download
            :title="selectedNotice.attachment.name"
          >
            <b-icon icon="download" />
            {{ selectedNotice.attachment.name }}
          </a>
        </div>
      </div>
      <template #modal-footer>
        <b-button variant="primary" @click="markNoticeAsRead(selectedNotice)">확인</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Notice from './Notice.js';
import NoticeTemplate from './NoticeTemplate.vue';
import * as ih from '@/components/util';
import { escapeHtml } from '@/components/sanitize.js';

export default {
  name: 'LogAndNotice',
  components: { NoticeTemplate },
  mixins: [Notice],
  data() {
    return {
      isNoticesCollapsed: true,
      isActivityLogsCollapsed: false,
      isMessagesCollapsed: false,
      selectedNotice: null,
      messageTabIndex: 0,
      searchKeyword: '',
      selectedIds: [],
      noticeForm: {
        title: '',
        content: ''
      },
      notice_list: [
        {
          notice_id: 2,
          title: 'QESG ERT 신규 기능 업데이트 안내',
          component: 'NoticeTemplate',
          sender_email: 'info@info.qesg.co.kr',
          time_stamp: '2026-04-17 12:00:00'
        }
      ]
    };
  },
  computed: {
    ...mapState('report_list', ['report_code', 'report_list']),
    ...mapState('logs', ['activity_logs', 'activity_logs_loaded', 'new_notice', 'mention_list']),
    ...mapState('story_board', [
      'editor_sb_toc',
      'editor_selected_lv2',
      'disclosures',
      'disclosures_loaded',
      'toc_loaded',
      'page_accessibility',
      'pending_open_comment_disclosure_id',
      'pending_open_comment_mention_id'
    ]),
    ...mapGetters('logs', ['unread_mentions', 'read_mentions']),
    ...mapState(['user_id', 'e_mail', 'is_admin']),
    userEmail() {
      return this.e_mail;
    },
    unreadCount() {
      return this.notice_list.filter(n => !this.isNoticeRead(n.notice_id)).length;
    },
    filteredUnreadMentions() {
      return this.filterBySearchKeyword(this.unread_mentions).slice().reverse();
    },
    filteredReadMentions() {
      return this.filterBySearchKeyword(this.read_mentions).slice().reverse();
    },
    isAllUnreadSelected() {
      return (
        this.filteredUnreadMentions.length > 0 &&
        this.filteredUnreadMentions.every(m => this.selectedIds.includes(m.id))
      );
    },
    isUnreadIndeterminate() {
      const count = this.filteredUnreadMentions.filter(m => this.selectedIds.includes(m.id)).length;
      return count > 0 && count < this.filteredUnreadMentions.length;
    },
    isAllReadSelected() {
      return (
        this.filteredReadMentions.length > 0 &&
        this.filteredReadMentions.every(m => this.selectedIds.includes(m.id))
      );
    },
    isReadIndeterminate() {
      const count = this.filteredReadMentions.filter(m => this.selectedIds.includes(m.id)).length;
      return count > 0 && count < this.filteredReadMentions.length;
    }
  },
  methods: {
    ...mapActions('logs', [
      'makeNoticeRead',
      'saveNotice',
      'readNoticesByUser',
      'deleteMentionFromList'
    ]),
    ...mapMutations('report_list', ['update_report_code', 'set_standard_mode']),
    ...mapActions('report_list', ['ensureReportLoadedForAdmin']),
    ...mapMutations('story_board', [
      'update_disclosures_loaded',
      'set_pending_open_comment_disclosure_id',
      'set_pending_open_comment_mention_id',
      'set_pending_lv_keys'
    ]),

    filterBySearchKeyword(list) {
      if (!this.searchKeyword) return list;
      const keyword = this.searchKeyword.toLowerCase();
      return list.filter(m => m.sender_name && m.sender_name.toLowerCase().includes(keyword));
    },

    toggleSelect(id) {
      const idx = this.selectedIds.indexOf(id);
      if (idx > -1) {
        this.selectedIds.splice(idx, 1);
      } else {
        this.selectedIds.push(id);
      }
    },

    toggleSelectAllUnread(checked) {
      if (checked) {
        const ids = this.filteredUnreadMentions.map(m => m.id);
        this.selectedIds = [...new Set([...this.selectedIds, ...ids])];
      } else {
        const ids = new Set(this.filteredUnreadMentions.map(m => m.id));
        this.selectedIds = this.selectedIds.filter(id => !ids.has(id));
      }
    },

    toggleSelectAllRead(checked) {
      if (checked) {
        const ids = this.filteredReadMentions.map(m => m.id);
        this.selectedIds = [...new Set([...this.selectedIds, ...ids])];
      } else {
        const ids = new Set(this.filteredReadMentions.map(m => m.id));
        this.selectedIds = this.selectedIds.filter(id => !ids.has(id));
      }
    },

    clearSelection() {
      this.selectedIds = [];
    },

    async deleteSelectedMentions() {
      if (this.selectedIds.length === 0) return;
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `${this.selectedIds.length}개 메시지를 삭제하시겠습니까?`,
        {
          title: '메시지 삭제',
          okVariant: 'danger',
          okTitle: '삭제',
          cancelTitle: '취소',
          centered: true
        }
      );
      if (!confirmed) return;

      const ids = [...this.selectedIds];
      const failed = [];
      for (const id of ids) {
        try {
          await axios.delete(`${this.$store.state.backend_host}/notice/${id}`);
          await this.deleteMentionFromList({ id });
        } catch (error) {
          failed.push(id);
          error.message = '[메시지 선택 삭제] ' + error.message;
          this.$Sentry.captureException(error);
        }
      }
      this.selectedIds = this.selectedIds.filter(id => failed.includes(id));
      if (failed.length === 0) {
        this.$EventBus.$emit('make-toast', '삭제 완료', `${ids.length}개 메시지를 삭제했습니다.`);
      } else {
        this.$EventBus.$emit(
          'make-toast',
          '삭제 실패',
          `${failed.length}개 메시지를 삭제하지 못했습니다. 다시 시도해주세요.`
        );
      }
    },

    async markSelectedAsRead() {
      if (this.selectedIds.length === 0) return;
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `${this.selectedIds.length}개 메시지를 읽음 처리하시겠습니까?`,
        {
          title: '메시지 읽음 처리',
          okVariant: 'primary',
          okTitle: '읽음 처리',
          cancelTitle: '취소',
          centered: true
        }
      );
      if (!confirmed) return;

      const ids = [...this.selectedIds];
      const failed = [];
      for (const id of ids) {
        try {
          const formData = new FormData();
          formData.append('notice_id', id);
          formData.append('user_id', this.user_id);
          formData.append('has_read', 'true');
          const response = await axios.post(
            `${this.$store.state.backend_host}/make_notice_read`,
            formData
          );
          const code = response.data && response.data.code;
          if (!code) {
            failed.push(id);
            continue;
          }
          this.$store.commit('logs/update_notice_read', { notice_id: id, code });
        } catch (error) {
          failed.push(id);
          error.message = '[메시지 선택 읽음 처리] ' + error.message;
          this.$Sentry.captureException(error);
        }
      }
      this.$store.commit('logs/update_new_notice');
      this.selectedIds = this.selectedIds.filter(id => failed.includes(id));
      if (failed.length === 0) {
        this.$EventBus.$emit(
          'make-toast',
          '읽음 처리 완료',
          `${ids.length}개 메시지를 읽음 처리했습니다.`
        );
      } else {
        this.$EventBus.$emit(
          'make-toast',
          '읽음 처리 실패',
          `${failed.length}개 메시지를 읽음 처리하지 못했습니다. 다시 시도해주세요.`
        );
      }
    },

    truncateText(text, maxLength) {
      if (text.length > maxLength) {
        return text.slice(0, maxLength) + '...';
      }
      return text;
    },

    highlightMentions(text) {
      if (!text) return '';
      return escapeHtml(text).replace(/@(\S+)/g, '<span class="mention-sender">@$1</span>');
    },

    // 메시지 미리보기 포맷터: 이미지 마크다운을 썸네일로, 나머지 텍스트만 truncate (issue #694)
    formatMentionPreview(content, maxLength) {
      if (!content) return '';
      const imageRegex = /!\[([^\]]*)\]\(([^)]+)\)/g;
      const images = [];
      const textOnly = content
        .replace(imageRegex, (_match, _alt, url) => {
          const decoded = url.replace(/&amp;/g, '&');
          if (/^https?:\/\//i.test(decoded)) {
            images.push(decoded);
            return ' ';
          }
          return '';
        })
        .replace(/\s+/g, ' ')
        .trim();

      const truncated = this.truncateText(textOnly, maxLength);
      const escapedText = escapeHtml(truncated).replace(
        /@(\S+)/g,
        '<span class="mention-sender">@$1</span>'
      );

      if (images.length === 0) return escapedText;

      // src 속성 안전성: HTML attribute에서 의미 있는 모든 문자 escape (formatComment 와 일관성)
      const safeUrl = images[0]
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
      const extraBadge =
        images.length > 1
          ? `<span class="mention-preview-img-badge">+${images.length - 1}</span>`
          : '';
      const imgHtml = `<span class="mention-preview-img-wrapper"><img src="${safeUrl}" alt="첨부 이미지" class="mention-preview-img" />${extraBadge}</span>`;

      return imgHtml + escapedText;
    },

    getReportName(report_code) {
      const idx = this.report_list.findIndex(x => x.report_code == report_code);
      if (idx > -1) {
        return this.report_list[idx].report_name;
      }
    },
    getMainColor(report_code) {
      const idx = this.report_list.findIndex(x => x.report_code == report_code);
      if (idx > -1) {
        return this.report_list[idx].main_color;
      }
    },

    getReadState(has_read) {
      if (has_read == false) {
        return '읽음 처리하기';
      }
    },

    handleNoticeRead(notice_id, has_read) {
      this.makeNoticeRead({ notice_id: notice_id, user_id: this.user_id, has_read: has_read });
    },

    openWriteNoticeModal() {
      this.$bvModal.show('write-notice-modal');
    },
    resetNoticeForm() {
      this.noticeForm.title = '';
      this.noticeForm.content = '';
    },
    submitNotice() {
      const noticeData = {
        title: this.noticeForm.title,
        content: this.noticeForm.content,
        sender_email: this.userEmail
      };
      this.saveNotice(noticeData)
        .then(() => {
          this.$bvModal.hide('write-notice-modal');
          this.resetNoticeForm();
          // 공지사항 목록 갱신
        })
        .catch(error => {
          error.message = '[공지사항 등록]' + error.message;
          this.$Sentry.captureException(error);
        });
    },
    openNoticeModal(notice) {
      this.selectedNotice = notice;
      this.$bvModal.show('notice-modal');
    },
    markNoticeAsRead(notice) {
      if (notice) {
        this.markNoticeIdAsRead(notice.notice_id);
      }
      this.$bvModal.hide('notice-modal');
      this.$emit('notice-read');
    },
    toggleCollapse(type) {
      if (type === 'notices') {
        this.isNoticesCollapsed = !this.isNoticesCollapsed;
      } else if (type === 'activityLogs') {
        this.isActivityLogsCollapsed = !this.isActivityLogsCollapsed;
      } else if (type === 'messages') {
        this.isMessagesCollapsed = !this.isMessagesCollapsed;
      }
    },
    formatTimestamp(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    formatContent(content) {
      if (!content) return '';
      return escapeHtml(content).replace(/\n/g, '<br>');
    },
    async handleMentionClick(mention) {
      // Layer 1: 사전 동기 검증 — disclosure/report 누락, 접근 불가 보고서 (issue #769).
      // removable=false인 경우(권한 부족 등)는 원본 메시지를 보존하고 토스트만 띄운다 (issue #835).
      const invalidReason = this._validateMentionTarget(mention);
      if (invalidReason) {
        if (invalidReason.removable) {
          await this._removeInvalidMention(mention.id, invalidReason.message);
        } else {
          this.$EventBus.$emit('make-toast', '메시지 이동 실패', invalidReason.message);
        }
        return;
      }

      // 같은 보고서이고 sb_toc가 이미 로드되어 있으면 lv1/lv2 키도 사전 검증.
      // 다른 보고서로 이동하는 경우엔 toc_loaded watcher에서 비동기 검증한다.
      if (this.report_code === mention.report_code && this.toc_loaded) {
        const lvReason = this._validateMentionLvKeys(mention);
        if (lvReason) {
          await this._removeInvalidMention(mention.id, lvReason);
          return;
        }
      }

      this.handleNoticeRead(mention.id, true);

      // 이동 후 해당 댓글이 자동으로 열리도록 disclosure_id를 store에 기록
      // CommentComponent가 mounted/watch에서 이 값을 보고 자기 댓글이면 자동 열기 (issue #694).
      // 함께 mention.id도 기록하여 disclosures/toc 로드 완료 후 race condition 검증에 사용 (issue #769).
      this.set_pending_open_comment_disclosure_id(mention.disclosure_id);
      this.set_pending_open_comment_mention_id(mention.id);

      const targetRoute = {
        name: 'WriteStoryBoard',
        query: {
          lv1: mention.sb_toc_lv1_key,
          lv2: mention.sb_toc_lv2_key
        },
        hash: '#sr_content_' + mention.disclosure_id
      };

      // NavigationDuplicated는 router.js 전역 override(push/replace)에서 무음 처리됨.
      // 그 외 router error는 그대로 throw되므로 별도 catch 없이 자연스럽게 노출된다.

      // 1) 다른 보고서: update_report_code를 router.push보다 먼저 호출한다 (issue #769).
      //    이렇게 하면 Header의 selected_report / is_able_to_edit이 새 보고서 기준으로
      //    즉시 계산되어 navigation 도중 viewer-only UI("결제 후 편집 가능")로 잠시 깜빡이는
      //    문제(production 환경에서 보였음)가 해결된다.
      //
      //    한편 selectLvFromRouteOrFirst는 $route.query를 보므로, push 전에 호출되는
      //    이 시점에는 옛 lv 값을 읽어 첫 lv로 튀는 #745 깜빡임이 재발할 수 있다.
      //    이를 막기 위해 lv1/lv2 키를 pending_lv_keys로 미리 전달하고
      //    selectLvFromRouteOrFirst가 그 값을 우선 사용하도록 한다.
      if (this.report_code !== mention.report_code) {
        this.set_pending_lv_keys({
          lv1: mention.sb_toc_lv1_key,
          lv2: mention.sb_toc_lv2_key
        });
        this.update_disclosures_loaded(false);
        // 관리자(is_admin === 4)가 본인이 팀원으로 속하지 않은 보고서에 진입하면
        // report_list에 해당 보고서가 없어 TopHeader의 selected_report가 빈 객체로 떨어진다
        // (제목 사라짐 + X 아이콘만 노출). landing 검색과 동일한 admin 검색 API로 단일 보고서를
        // 먼저 가져와 report_list에 병합한 뒤 navigation을 진행한다 (issue #855).
        if (this.is_admin === 4) {
          await this.ensureReportLoadedForAdmin({ report_code: mention.report_code });
        }
        this.update_report_code(mention.report_code);
        // NavigationDuplicated는 router.js 전역 override가 무음 처리하지만,
        // beforeEach 가드의 cancel 등 다른 reject는 그대로 propagate된다.
        // await을 의도적으로 생략하여 update_report_code 직후 Header가 즉시 갱신되도록 하므로
        // unhandled rejection 방지를 위해 명시적으로 Sentry로 보고한다.
        this.$router.push(targetRoute).catch(err => {
          err.message = '[메시지함 댓글 이동 router.push] ' + err.message;
          this.$Sentry.captureException(err);
        });
        return;
      }

      // 2) 같은 보고서이지만 다른 페이지에 있는 경우: router.push로 이동
      if (this.$route.name !== 'WriteStoryBoard') {
        this.$router.push(targetRoute);
        return;
      }

      // 3) 같은 보고서 + 이미 WriteStoryBoard: query/hash만 동기화하면
      //    StoryBoardWritingMaster의 $route watcher가 lv1/lv2를 commit한다.
      const currentQuery = this.$route.query || {};
      const queryChanged =
        currentQuery.lv1 !== targetRoute.query.lv1 || currentQuery.lv2 !== targetRoute.query.lv2;

      if (queryChanged) {
        this.$router.replace({ query: targetRoute.query, hash: targetRoute.hash });
      } else {
        // lv까지 동일 → hash만 갱신하고 anchor로 스크롤.
        // 이 경로에서는 fetch_sb_disclosures가 새로 호출되지 않아 disclosures_loaded
        // watcher가 fire되지 않으므로, disclosure 존재 여부를 즉시 확인한다 (issue #769).
        const stillExists = this.disclosures.some(d => d.id === mention.disclosure_id);
        if (!stillExists) {
          await this._removeInvalidMention(
            mention.id,
            '이미 삭제된 요소입니다. 메시지에서 자동 제거됩니다.'
          );
          return;
        }
        location.hash = targetRoute.hash;
        ih.anchorGo(location.hash);
      }
    },

    // 사전 검증: disclosure_id / report_code 누락, 보고서 접근 불가 (issue #769).
    // 반환 형식 { removable, message } — removable=true면 메시지함에서 자동 제거,
    // false면 토스트만 띄우고 원본 메시지는 보존 (issue #835).
    _validateMentionTarget(mention) {
      if (!mention.disclosure_id) {
        return {
          removable: true,
          message: '이미 삭제된 요소입니다. 메시지에서 자동 제거됩니다.'
        };
      }
      if (!mention.report_code) {
        return {
          removable: true,
          message: '이미 삭제된 보고서입니다. 메시지에서 자동 제거됩니다.'
        };
      }
      // 관리자(is_admin === 4)는 모든 보고서에 대해 접근/읽기/편집 권한이 있으므로
      // report_list 멤버십 검사를 건너뛴다. 관리자의 report_list에는 본인이 직접
      // 참여 중인 보고서만 들어있어 false negative가 발생할 수 있다 (issue #835).
      if (this.is_admin === 4) {
        return null;
      }
      const accessible = this.report_list.some(r => r.report_code === mention.report_code);
      if (!accessible) {
        // 권한 문제는 "삭제된 요소"가 아니므로 원본 메시지를 보존한다 (issue #835).
        return {
          removable: false,
          message: '접근 권한이 없는 보고서입니다.'
        };
      }
      return null;
    },

    // sb_toc에 lv1/lv2 키가 살아있는지 검증 (issue #769).
    // selectLvFromRouteOrFirst(StoryBoardWritingMaster.vue)와 동일한 매칭 규칙을 사용해야
    // navigation 후속 흐름과 split-brain이 발생하지 않는다: key 또는 decodeKey(name).
    _validateMentionLvKeys(mention) {
      if (!this.editor_sb_toc || this.editor_sb_toc.length === 0) return null;
      const lv1Key = mention.sb_toc_lv1_key;
      const lv2Key = mention.sb_toc_lv2_key;
      const lv1 = this.editor_sb_toc.find(
        item => item.key === lv1Key || this._decodeTocKey(item.name) === lv1Key
      );
      if (!lv1) return '이미 삭제된 요소입니다. 메시지에서 자동 제거됩니다.';
      const lv2 = (lv1.children || []).find(
        item => item.key === lv2Key || this._decodeTocKey(item.name) === lv2Key
      );
      if (!lv2) return '이미 삭제된 요소입니다. 메시지에서 자동 제거됩니다.';
      return null;
    },

    // sb_toc 항목 name의 URL-encoded 공백/줄바꿈을 복원해 mention의 lv 키와 비교 가능하게 만든다.
    // StoryBoardWritingMaster.selectLvFromRouteOrFirst와 동일한 규칙.
    _decodeTocKey(key) {
      return (key || '').replace(/%20/g, ' ').replace(/%0A/g, '\n');
    },

    // 현재 store의 report_code/selected_lv2가 mention의 target과 일치하는지 검증 (issue #795).
    // disclosures_loaded는 cross-report navigation 중 중간 상태(이전 보고서의 lv2 fetch,
    // 실패한 fetch 등)에서도 true로 전이될 수 있다. 이 시점의 disclosures 배열은 mention의
    // target lv2가 아니므로 disclosure_id가 발견되지 않더라도 "삭제됨"으로 판단하면 안 된다.
    // page_accessibility=false 인 경우는 fetch 실패로 disclosures가 갱신되지 않은 상태이므로
    // 동일하게 판단을 보류한다.
    _isStoreContextForMention(mention) {
      if (this.report_code !== mention.report_code) return false;
      if (!this.page_accessibility) return false;
      const lv2 = this.editor_selected_lv2;
      if (!lv2) return false;
      const lv2Key = mention.sb_toc_lv2_key;
      return lv2.key === lv2Key || this._decodeTocKey(lv2.name) === lv2Key;
    },

    // 이동 불가/실패 시 토스트 표시 + 메시지함에서 자동 제거 (issue #769).
    // 백엔드 삭제 실패해도 로컬 list에서는 제거하여 동일 메시지의 반복 클릭을 차단한다.
    async _removeInvalidMention(mentionId, toastMessage) {
      this.$EventBus.$emit('make-toast', '메시지 이동 실패', toastMessage);
      this.set_pending_open_comment_disclosure_id(null);
      this.set_pending_open_comment_mention_id(null);
      try {
        await axios.delete(`${this.$store.state.backend_host}/notice/${mentionId}`);
      } catch (error) {
        error.message = '[삭제된 댓글 메시지 자동 제거] ' + error.message;
        this.$Sentry.captureException(error);
      }
      this.deleteMentionFromList({ id: mentionId });
    }
  },
  watch: {
    messageTabIndex() {
      this.selectedIds = [];
    },
    // Layer 3: 다른 보고서로 이동한 경우 sb_toc 로드 완료 시점에 lv1/lv2 키 검증 (issue #769).
    // 같은 보고서 클릭은 handleMentionClick에서 인라인 검증되므로 여기로 들어오지 않는다.
    toc_loaded(loaded) {
      if (!loaded) return;
      const mentionId = this.pending_open_comment_mention_id;
      if (!mentionId) return;
      const mention = this.mention_list.find(m => m.id === mentionId);
      if (!mention) return;
      // 로드된 editor_sb_toc가 mention의 target 보고서가 맞을 때만 lv 검증을 진행한다 (issue #795).
      // 빠른 보고서 전환·중간 fetch 등으로 toc_loaded가 아직 옛 보고서 상태에서 true가 될 수 있고,
      // 이 시점에 mention의 lv를 옛 toc와 비교하면 false positive 삭제가 발생한다.
      if (this.report_code !== mention.report_code) return;
      const lvReason = this._validateMentionLvKeys(mention);
      if (lvReason) {
        this._removeInvalidMention(mentionId, lvReason);
      }
      // lv가 유효하면 후속 disclosures_loaded watcher에서 disclosure 존재까지 검증한다.
    },
    // Layer 2: disclosures 로드 완료 시점에 mention.disclosure_id가 실제 존재하는지 검증 (issue #769).
    // 매칭 성공 시 CommentComponent가 자동으로 댓글을 열고 pending 상태를 정리한다.
    disclosures_loaded(loaded) {
      if (!loaded) return;
      const mentionId = this.pending_open_comment_mention_id;
      if (!mentionId) return;
      const mention = this.mention_list.find(m => m.id === mentionId);
      // 이미 다른 경로에서 mention이 list에서 제거된 경우 pending만 정리
      if (!mention) {
        this.set_pending_open_comment_mention_id(null);
        return;
      }
      // disclosures가 mention의 target 컨텍스트(보고서·lv2)에서 로드된 것인지 확인 (issue #795).
      // 보고서 전환 중에는 이전 보고서/다른 lv2의 fetch나 실패한 fetch로 disclosures_loaded가
      // 먼저 true로 전이될 수 있다. 이 경우 disclosures에는 mention의 target lv2 데이터가 없으므로
      // disclosure_id 부재를 곧바로 "삭제됨"으로 판단해선 안 되고, 후속 fetch의 disclosures_loaded
      // 전이를 기다린다.
      if (!this._isStoreContextForMention(mention)) return;
      const found = this.disclosures.some(d => d.id === mention.disclosure_id);
      if (!found) {
        this._removeInvalidMention(
          mentionId,
          '이미 삭제된 요소입니다. 메시지에서 자동 제거됩니다.'
        );
      } else {
        // 정상 매칭 — CommentComponent가 자동 열기를 처리하므로 mention_id만 비운다.
        this.set_pending_open_comment_mention_id(null);
      }
    }
  }
};
</script>

<style>
.collapse-icon {
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.button-with-icon:hover .collapse-icon {
  opacity: 1;
}

.notice-card:hover {
  border-color: var(--gray-700);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.mention-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.mention-label-report,
.mention-label-topic {
  display: inline-block;
  padding: 1px 6px;
  border-radius: 3px;
  font-size: 0.75rem;
  line-height: 1.4;
}

.mention-label-report {
  background-color: #e6f5ec;
  color: #1a7a3a;
  font-weight: 600;
}

.mention-label-topic {
  background-color: #f0f0f0;
  color: #666;
  font-weight: 500;
}

.mention-sender {
  color: #2b7de9;
  font-weight: 600;
  margin-right: 4px;
}

.mention-timestamp {
  font-size: 0.75rem;
  color: #999;
}

.mention-card-read {
  opacity: 0.7;
}

.mention-card-selected {
  border-color: #2b7de9;
  background-color: #f0f7ff;
}

/* 메시지 미리보기 첨부 이미지 썸네일 (issue #694) */
.mention-preview-img-wrapper {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
}

.mention-preview-img {
  max-width: 100%;
  max-height: 160px;
  object-fit: contain;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  background-color: #fafafa;
}

.mention-preview-img-badge {
  font-size: 0.8rem;
  color: #666;
  background-color: #f0f0f0;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
}
</style>
